import React from "react";
import classNames from "classnames";
import { DropzoneRootProps } from "react-dropzone";
import styles from "./FileDropzone.module.scss";

interface FileDropzoneProps {
    rootProps: DropzoneRootProps;
    isDragActive: boolean;
    cover?: React.ReactNode;
    coverClassName?: string;
    className?: string;
    children?: React.ReactNode;
    "data-testid"?: string;
}

export const FileDropzone: React.FC<FileDropzoneProps> = ({
    rootProps,
    isDragActive,
    cover,
    coverClassName,
    className,
    children,
    "data-testid": dataTestId,
}) => {
    // rootProps may carry its own className (getRootProps({ className })); merge
    // instead of letting the spread clobber the DS base class or the test id.
    const { className: rootClassName, ...restRootProps } = rootProps;

    return (
        <div
            {...restRootProps}
            className={classNames(styles.dropzone, className, rootClassName)}
            data-testid={dataTestId}
        >
            {children}

            {cover !== null && (
                <aside
                    className={classNames(styles.cover, coverClassName, {
                        [styles.coverActive]: isDragActive,
                    })}
                >
                    {cover}
                </aside>
            )}
        </div>
    );
};
